import { render, staticRenderFns } from "./HelpAssistantWidget.vue?vue&type=template&id=2f1bc6df&scoped=true"
import script from "./HelpAssistantWidget.vue?vue&type=script&lang=js"
export * from "./HelpAssistantWidget.vue?vue&type=script&lang=js"
import style0 from "./HelpAssistantWidget.vue?vue&type=style&index=0&id=2f1bc6df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1bc6df",
  null
  
)

export default component.exports